import { useInView as useInViewOriginal } from "react-intersection-observer";

export const useInView = (
  options?: Parameters<typeof useInViewOriginal>[0]
) => {
  return useInViewOriginal({
    threshold: 0.1,
    triggerOnce: true,
    ...options,
  });
};
